import * as bootstrap from "bootstrap"

// Bridge between the web view and the Hotwire Native shells.
//
// Exposed on `window` so the native side can call into it, and imported by
// Stimulus controllers to send messages out. Both branches of `postMessage`
// are silent no-ops in a plain browser, so the same bundle ships everywhere
// and call sites never need to guard.
class Bridge {
  // Opens the navbar, which starts collapsed in the +native layout variant.
  static toggleNavBar() {
    const element = document.getElementById("nativeMenu")
    if (!element) return

    return new bootstrap.Collapse(element)
  }

  // Sets the badge count on the app icon and on the current tab.
  // 0 clears the badge; null leaves it untouched.
  static setNotificationCount(icon, tab = icon) {
    this.postMessage("showNotificationBadge", { icon, tab })
  }

  // Send a message to the native app, if there is one.
  static postMessage(name, data = {}) {
    // iOS
    window.webkit?.messageHandlers?.nativeApp?.postMessage({ name, ...data })
    // Android
    window.nativeApp?.postMessage(JSON.stringify({ name, ...data }))
  }
}

// Exposed so the native shells can reach it
window.TurboNativeBridge = Bridge

export default Bridge
